import * as React from 'react';
import { SVGProps } from 'react';

const IconPressureStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.075 7.997a1 1 0 0 1-1.05-1.216L5.604 5.14l.534-.534L7.78 6.024a1 1 0 0 1 1.216 1.05L10.068 8 9 9.068l-.925-1.07Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 12.659a6 6 0 1 0-4 0V13H4v2h8v-2h-2v-.341ZM12 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
    />
  </svg>
);
export default IconPressureStrokedSizeS;
